import { render } from "./UIDivider.vue?vue&type=template&id=37dbf164&scoped=true"
const script = {}

import "./UIDivider.vue?vue&type=style&index=0&id=37dbf164&scoped=true&lang=css"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37dbf164"]])

export default __exports__